/**
 * AUTO-GENERATED from schema.json — DO NOT EDIT
 * Source: FAQs (faqs)
 * Run `yarn workspace @library/cms-blocks cms:types` to regenerate
 */

import { z } from 'zod'
import { RichTextContentSchema } from '../../types/contentstack-zod'

export const FaqsFieldsSchema = z
  .object({
    heading: z.string().max(120),
    body: z
      .array(
        z.object({ title: z.string().max(200), description: RichTextContentSchema }).passthrough(),
      )
      .nullish(),
  })
  .passthrough()
